<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="12" viewBox="0 0 68 50">
    <g>
      <g>
        <g>
          <g>
            <g>
              <path fill="#71767D"
                d="M20.395 44.7a1.75 1.75 0 0 0-2.25-1.035l-6.597 2.44a1.75 1.75 0 0 0 1.215 3.284l6.597-2.44a1.75 1.75 0 0 0 1.035-2.25z" />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path fill="#71767D"
                d="M11.466 28.447a1.751 1.751 0 0 0-2.25-1.034l-4.072 1.506a1.75 1.75 0 0 0 1.215 3.284l4.072-1.507a1.75 1.75 0 0 0 1.035-2.249z" />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path fill="#71767D"
                d="M6.417 41.708a1.75 1.75 0 0 0-2.249-1.034l-3.026 1.12a1.75 1.75 0 0 0 1.215 3.283l3.026-1.12a1.75 1.75 0 0 0 1.034-2.249z" />
            </g>
          </g>
        </g>
        <g>
          <g>
            <path fill="#3b334a"
              d="M61.994 4.84L38.735 27.343 20.362 21.79zm-4.168 35.376L41.05 28.602 64.575 5.844zm-16.94-.973l-.42-8 4.711 3.258zM17.74 21.944a2.433 2.433 0 0 0 1.74 2.202l18.395 5.562.676 12.679c.03.502.369.942.85 1.106a1.244 1.244 0 0 0 1.352-.348l6.503-7.2 9.218 6.38c.41.287.891.44 1.393.44 1.157 0 2.161-.818 2.407-1.966l7.65-38.99a1.256 1.256 0 0 0-.43-1.208 1.244 1.244 0 0 0-1.27-.195l-47.01 19.132c-.952.43-1.536 1.372-1.474 2.406z" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#71767D',
    },
    size: {
      type: Number,
      default: 13,
    },
  },
};
</script>
